<section id="market-seo">
  <div style="background: #F9F9F9;" class="pt-4 pt-md-0">
  <div id="mainBannerMarket" class="mx-4 mx-md-0">
      <div
        class="mainBanner-container position-relative d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-xxl-around px-4 pt-4">
        <div id="download-apps-top" class="d-flex flex-column align-items-center align-items-md-start pl-lg-5 pr-xl-5" style="flex:60%">
          <h1 class="h2 font-weight-bold  Poppins text-center text-md-left text-white"><span>Cubatel
          Market</span><br>
          </h1>
          <p class="text-left pt-2 Poppins font-weight-bold text-center text-md-left text-white" style="font-size: 20px">¡Somos el Amazon cubano con<br> entregas a domicilio en todas las provincias!</p>
          <div class="d-flex justify-content-md-start justify-content-center"><button routerLink="productos-compras-cuba-online"
                                                                                      class="btn bg-white btn-success mt-4 px-4 py-2 py-lg-3 font-weight-bold OpenSans rounded-pill product-button"
                                                                                      style="color: #3ba694; font-size: 20px">
            Ver Productos
          </button></div>

          <img class="w-100 d-flex d-md-none" src="assets/market/panfilo-tienda-1.png"
               alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        </div>
        <div class="d-none d-md-flex pl-5 pl-md-4">
          <img class="w-100" src="assets/market/panfilo-tienda-1.png"
               alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        </div>
      </div>
    </div>
  </div>
  <!--END-MAIN-BANNER-->

  <!--CATEGORIES SLIDER-->
  <app-categories-section></app-categories-section>
  <!--END CATEGORIES SLIDER-->

  <!-- WALMART SECTION -->
  <ng-container *ngIf="turnOnWalmart">
    <app-walmart-banner></app-walmart-banner>
  </ng-container>

  <!-- END WALMART SECTION --->

  <!-- HOME DEPOT SECTION -->
  <ng-container *ngIf="turnOnHomeDepot">
    <app-home-depot-banner></app-home-depot-banner>
  </ng-container>

  <!-- END HOME DEPOT SECTION --->

  <!-- HOME BEST BUY SECTION -->
  <ng-container *ngIf="turnOnBestBuy">
    <app-best-buy-banner></app-best-buy-banner>
  </ng-container>

  <!-- END HOME DEPOT SECTION --->

  <!-- SHEIN SECTION -->
  <ng-container *ngIf="turnOnShein">
    <app-shein-banner></app-shein-banner>
  </ng-container>

  <!-- END SHEIN SECTION --->

  <!-- AMAZON SECTION -->
  <ng-container *ngIf="turnOnAmazon">
  <app-ammazon-banner></app-ammazon-banner>
  </ng-container>
  <!-- END AMAZON SECTION --->

  <!--PRODUCTS SECTION-->
  <app-products-section></app-products-section>
  <!--END PRODUCTS SECTION-->



  <!--SHIPPING SECTION-->
  <app-shipping-section></app-shipping-section>
  <!--END SHIPPING SECTION-->

  <!-- STORE SECTION -->
  <section id="store-section" class="feat-pro2" style="min-height: 712px">
    <div class="container px-0 pt-4">
      <div class="row py-4">
        <div class="col-md-12 d-flex flex-column">
          <h2 class="p-2 font-weight-bold text-center with-line section-title">Tiendas populares</h2>
          <p class="text-center" style="font-size: 18px">Descubre miles de productos con entrega a domicilio para tu familia en Cuba</p>
          <a style="color: #0C8EFE" class="d-block d-md-none w-100 text-right mt-2" routerLink="tiendas-asociadas">Ver todas</a>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center position-relative" style="min-height: 100px">
        <div id="stores_section" #stores_section></div>
      </div>

    </div>
  </section>
  <!-- END STORE SECTION -->

  <!--MOST POPULAR SECTION -->
  <app-most-popular-section></app-most-popular-section>
  <!--END MOST POPULAR SECTION -->

  <!--RECOMMENDED PRODUCTS SECTION-->
  <section id="products-recommended-section" class="feat-pro2" style="min-height: 581px">
    <div class="container px-0 pt-4">
      <div class="row py-4">
        <div class="col-md-12 d-flex flex-column">
          <h2 class="p-2 font-weight-bold text-center with-line section-title">Artículos que pueden interesarte</h2>
        </div>
        <a class="d-block d-md-none w-100 text-center" routerLink="/market/productos">Ver todos</a>
      </div>
      <div class="d-flex flex-column align-items-center position-relative" style="min-height: 100px">
        <div id="recommended_products_section" #recommended_products_section></div>
      </div>

    </div>
  </section>
  <!--END RECOMMENDED PRODUCTS SECTION-->

  <!--SHIPPING SECTION-->
  <app-shipping-amazon-section [title]="'Formas de enviar tus compras a Cuba'" [provider]="ProviderType.Internal"></app-shipping-amazon-section>
  <!--END SHIPPING SECTION-->

  <!--FAQS SECTION-->
  <section id="market-list-faq" class="d-flex justify-content-center p-0 paginated ">
    <div class="container">
      <div class="row py-4">
        <div class="col-md-12 d-flex flex-column">
          <h2 class="p-2 font-weight-bold text-center with-line section-title">Preguntas frecuentes</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <article class="col-12 col-lg-12 col-md-12">
            <div class="accordion" id="faq">
              <div class="card  mt-2">
                  <div class="card-header" id="heading-comida-1" data-toggle="collapse" data-target="#collapse-comida-1" style="background: #fff">
                    <h3 class="mb-0 text-left">
                      <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                              data-target="#collapse-comida-1" aria-expanded="false" aria-controls="collapse-comida-1">
                        ¿Cuánto demora un paquete por Cubatel Market a Cuba?
                      </button>
                    </h3>
                  </div>
                  <div id="collapse-comida-1" class="collapse" aria-labelledby="heading-comida-1" data-parent="#faq">
                    <div class="card-body">
                      <p class=" w-100 text-justify ">
                        Los tiempos de entrega varían según las tiendas online con envío a Cuba.
                        Pueden demorarse desde 24/48 horas hasta 4 o 7 semanas si se realizan por vía marítima a Cuba.
                      </p>
                    </div>
                  </div>
                </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-2" data-toggle="collapse" data-target="#collapse-comida-2" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-2" aria-expanded="false" aria-controls="collapse-comida-1">
                      ¿Los envíos son a todas las provincias de Cuba?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-2" class="collapse" aria-labelledby="heading-comida-2" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Antes de agregar el producto, deberás seleccionar la provincia y municipio al que quieres enviar. Si existe disponibilidad para esa ubicación, podrás comprar en enviarlo.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-3" data-toggle="collapse" data-target="#collapse-comida-3" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-3" aria-expanded="false" aria-controls="collapse-comida-1">
                      ¿Qué necesito para comprar en Cubatel Market?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-3" class="collapse" aria-labelledby="heading-comida-3" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Debes tener una cuenta creada en nuestra plataforma. Una vez seleccionados los productos y elegida la ubicación de entrega, deberás proveer los datos de la persona que lo recibe (nombre, dirección y teléfono de contacto).
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-4" data-toggle="collapse" data-target="#collapse-comida-4" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-4" aria-expanded="false" aria-controls="collapse-comida-1">
                      ¿Cuándo puedo cancelar mi orden?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-4" class="collapse" aria-labelledby="heading-comida-4" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Puedes cancelar tu orden siempre y cuando no la hayamos tramitado con el proveedor. Contacta con nosotros lo antes posible si quieres desistir de la compra.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-5" data-toggle="collapse" data-target="#collapse-comida-5" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-5" aria-expanded="false" aria-controls="collapse-comida-1">
                      ¿Cuál es el máximo de envíos que puedo realizar?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-5" class="collapse" aria-labelledby="heading-comida-5" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      No hay límites de envíos. Puedes realizar tantas compras como quieras a través de todas nuestras tiendas asociadas.
                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-6" data-toggle="collapse" data-target="#collapse-comida-6" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-6" aria-expanded="false" aria-controls="collapse-comida-1">
                      Cómo puedo pagar en el Market?
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-6" class="collapse" aria-labelledby="heading-comida-6" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify ">
                      Puedes pagar con tus tarjetas de crédito o débito. Si quieres, puedes guardar tu tarjeta una sola vez y pagar automáticamente todas sus compras.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
  <!--END FAQS SECTION-->

  <!--MARKET FOOTER-->
  <div id="footer-info" >
    <div class="container px-0 py-4">
      <div class="d-flex flex-column flex-md-row justify-content-between p-4">
        <div class="d-flex flex-column flex-xl-row align-items-center justify-content-start justify-content-xl-between p-2" style="flex:20%">
          <img width="50" height="50" src="assets/market/rocket.svg" />
          <div class="d-flex flex-column ml-2">
            <span class="font-weight-bold text-center text-xl-left">Envío rápido</span>
            <p class="text-center text-xl-left">Recibe tu pedido sin demoras</p>
          </div>
        </div>
        <div class="d-flex flex-column flex-xl-row align-items-center justify-content-start justify-content-xl-between p-2" style="flex:20%">
          <img width="50" height="50" src="assets/market/umbrella.svg" />
          <div class="d-flex flex-column ml-2">
            <span class="font-weight-bold text-center text-xl-left">Protección</span>
            <p class="text-center text-xl-left">Protegemos tus compras hasta el domicilio</p>
          </div>
        </div>
        <div class="d-flex flex-column flex-xl-row align-items-center justify-content-start justify-content-xl-between p-2" style="flex:20%">
          <img width="50" height="50" src="assets/market/card.svg" />
          <div class="d-flex flex-column ml-2">
            <span class="font-weight-bold text-center text-xl-left">Pago seguro</span>
            <p class="text-center text-xl-left">Sistema fácil y confiable para cuidar tu dinero</p>
          </div>
        </div>
        <div class="d-flex flex-column flex-xl-row align-items-center justify-content-start justify-content-xl-between p-2" style="flex:20%">
          <img width="50" height="50" src="assets/market/support.svg" />
          <div class="d-flex flex-column ml-2">
            <span class="font-weight-bold text-center text-xl-left">Recibes soporte</span>
            <p class="text-center text-xl-left">Estamos disponibles todos los días de 8 am a 10 pm. </p>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!--END MARKET FOOTER-->

  <!-- APPS SECTION # 2 -->
  <div id="appsSection2" class="pt-5 px-5 stu-bg-primary d-flex flex-column align-items-center">
    <div class="d-flex flex-column justify-content-center mt-md-4 mt-xl-5 pt-xl-5">
      <h2 class="h2 text-white Poppins font-weight-bold text-center text-md-left">Descarga nuestra App</h2>
      <div class="d-flex pt-md-5 justify-content-between flex-column flex-md-row">
        <div class="d-flex flex-column">
          <p class="text-white Poppins d-none d-md-flex">Hemos creado la<br />
            aplicación más sencilla <br />
            de servicios a Cuba.<br />
            LLamadas, envío de dinero, <br />
            recargas para Cuba y más.<br />
            Confía en nosotros <br />
            y hazte Cubatel.</p>
          <div class="d-flex mt-4 align-items-center flex-column flex-md-row">
            <picture class="d-none d-md-flex">
              <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/4.9.webp" type="image/webp">
              <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/4.9.png" type="image/png">
              <img width="149" height="149" class="lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/4.9.png"
                   alt="4.9">
            </picture>
            <picture class="d-flex d-md-none">
              <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/4.9.webp" type="image/webp">
              <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/4.9.png" type="image/png">
              <img width="112" height="112" class="lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/4.9.png"
                   alt="4.9">
            </picture>
            <p class="text-white ml-0 ml-md-4 Poppins mt-3 text-center text-md-left">Somos la App mejor<br>
              valorada de <br>
              Recargas para Cuba</p>
          </div>
        </div>
        <div class="position-relative d-flex align-items-end justify-content-center">
          <picture class="d-none d-md-flex">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/mobile-app.webp" type="image/webp">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/mobile-app.png" type="image/png">
            <img width="379" class="lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/mobile-app.png"
                 alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
          </picture>
          <picture class="d-flex d-md-none">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/mobile-app.webp" type="image/webp">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets-v3/home/mobile-app.png" type="image/png">
            <img width="268" height="323" class="lazyload"
                 data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/mobile-app.png"
                 alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
          </picture>
          <div id="appsSection2-imgs" class="d-flex flex-column position-absolute mb-3">
            <a class="d-block d-md-none my-2 bg-transparent text-decoration-none p-0"
               href="https://play.google.com/store/apps/details?id=com.cubatel.android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
               rel="noreferrer" target="_blank" aria-label="Google Play">
              <img width="177" height="52" class="lazyload "
                   data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/google-play-black.svg" alt="Google Play">
            </a>
            <a class="d-none d-md-block my-2 bg-transparent text-decoration-none p-0"
               href="https://play.google.com/store/apps/details?id=com.cubatel.android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
               rel="noreferrer" target="_blank" aria-label="Google Play">
              <img width="255" height="75" class="lazyload "
                   data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/google-play-black.svg" alt="Google Play">
            </a>
            <a class="d-none d-md-block my-2 bg-transparent text-decoration-none p-0"
               href="https://itunes.apple.com/us/app/cubatel/id1300396049" rel="noreferrer" target="_blank"
               aria-label="App Store">
              <img width="255" height="75" class="lazyload d-none d-md-block"
                   data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/app-store-black.svg" alt="App Store">
            </a>
            <a class="d-block d-md-none my-2 bg-transparent text-decoration-none p-0"
               href="https://itunes.apple.com/us/app/cubatel/id1300396049" rel="noreferrer" target="_blank"
               aria-label="App Store">
              <img width="177" height="52" class="lazyload "
                   data-src="https://www.cubatel.com/images-ads/cdn/assets-v3/home/app-store-black.svg" alt="App Store">
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- END APPS SECTION # 2 -->
</section>

<ng-template #snippet>
  <div class="backdrop" style="border-radius: 8px">
    <div class="text-center">
      <picture>
        <source srcset="assets/loading.webp" type="image/webp">
        <source srcset="assets/loading.gif" type="image/gif">
        <img style="height: 70px; width:70px" src="assets/imgs/loading.gif" alt="Cargando...">
      </picture>
    </div>
  </div>
</ng-template>
